// Safari sur iPhone n'ouvre le clavier que pour un focus venu d'un toucher : le champ d'une page
// où l'on arrive (la recherche, ouverte depuis le champ de l'en-tête ou l'onglet Rechercher)
// prenait le focus sans clavier, et il fallait le toucher encore. Un champ relais, focalisé
// pendant le toucher, garde le clavier ouvert le temps de la visite. Posé hors du <body>, que
// Turbo remplace, il survit au rendu ; une fois la page chargée, il passe le focus, et ce qui a
// déjà été tapé, à son champ `autofocus`.
const TIMEOUT_MS = 8000

let relay = null
let timer = null

export function holdKeyboardUntilNextPage() {
  release()

  relay = document.createElement("input")
  relay.type = "search"
  relay.tabIndex = -1
  relay.autocomplete = "off"
  relay.enterKeyHint = "search"
  relay.setAttribute("aria-hidden", "true")
  relay.style.cssText =
    "position: fixed; top: 0; left: 0; width: 1px; height: 1px; padding: 0; border: 0; opacity: 0; font-size: 16px; pointer-events: none;"
  document.documentElement.append(relay)
  relay.focus({ preventScroll: true })

  document.addEventListener("turbo:before-render", deferAutofocus)
  document.addEventListener("turbo:load", handOver)
  timer = setTimeout(release, TIMEOUT_MS)
}

// Turbo donnerait le focus au champ `autofocus` dès le rendu, y compris à celui de l'aperçu en
// cache, que le rendu final remplace : focus perdu, clavier refermé. Le relais le garde jusqu'au
// chargement.
function deferAutofocus(event) {
  event.detail.newBody.querySelectorAll("[autofocus]").forEach((element) => {
    element.removeAttribute("autofocus")
    element.dataset.keyboardRelayFocus = ""
  })
}

function handOver() {
  const target = document.body.querySelector("[data-keyboard-relay-focus]")

  if (target && relay && document.activeElement === relay) {
    target.focus({ preventScroll: true })

    if (relay.value) {
      target.value = relay.value
      target.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  release()
}

function release() {
  clearTimeout(timer)
  document.removeEventListener("turbo:before-render", deferAutofocus)
  document.removeEventListener("turbo:load", handOver)
  relay?.remove()
  relay = null
}
